'use client';
import { jsx } from 'react/jsx-runtime';
import { TriangleDownIcon } from './number-input-icons.mjs';
import { useNumberInputStyles, useNumberInputContext } from './number-input-context.mjs';
import { StyledStepper } from './styled-stepper.mjs';
import { forwardRef } from '../system/forward-ref.mjs';

const NumberInputDecrementStepper = forwardRef(function NumberDecrementStepper(props, ref) {
  const styles = useNumberInputStyles();
  const { getDecrementButtonProps } = useNumberInputContext();
  const decrement = getDecrementButtonProps(props, ref);
  return /* @__PURE__ */ jsx(StyledStepper, { ...decrement, __css: styles.stepper, children: props.children ?? /* @__PURE__ */ jsx(TriangleDownIcon, {}) });
});
NumberInputDecrementStepper.displayName = "NumberInputDecrementStepper";

export { NumberInputDecrementStepper };
